<template>
  <div class="text-input">
    <ValidationProvider
      v-slot="{ errors }"
      :name="label"
      :rules="validationRules"
    >
      <div class="vx-row">
        <div class="vx-col w-full lg:w-1/2">
          <label
            v-if="label || required"
            :for="`input-${name}`"
            class="vs-input--label mb-1"
            >{{ label }}
            <span v-if="required" class="text-danger"
              ><feather-icon icon="star-of-life"/></span
          ></label>
          <vs-input
            type="file"
            class="w-full data-input"
            :placeholder="placeholder"
            :name="name"
            :disabled="uploading"
            accept="image/*"
            :class="{ error: errors.length }"
            @change="filesChange($event.target.files)"
          />
        </div>
        <div class="vx-col w-full lg:w-1/2">
          <img v-if="imageUrl" class="mb-2 w-full md:w-1/3" :src="imageUrl" />
        </div>
      </div>
      <span v-show="errors.length" class="text-danger text-sm">{{
        errors[0]
      }}</span>
    </ValidationProvider>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: [String, Number], default: null },
    validationRules: {
      type: [Object, String],
      default() {
        return null;
      }
    },
    label: { type: String, default: null },
    placeholder: { type: String, default: null },
    name: { type: String, required: true },
    type: { type: String, default: "text" },
    publicFile: { type: Boolean, default: false },
    required: { type: Boolean, default: false }
  },
  data: () => ({
    uploading: false,
    imageUrl: null
  }),
  watch: {
    value: {
      immediate: true,
      handler(v) {
        if (v) {
          this.downloadImage(v);
        } else {
          this.imageUrl = null;
        }
      }
    }
  },
  methods: {
    async downloadImage(file) {
      const { data } = await this.$axiosStorageApi({
        url: `/file/${file}/download_auth`,
        method: "GET",
        responseType: "blob"
      });

      let reader = new FileReader();
      reader.readAsDataURL(data);
      reader.onloadend = () => {
        this.imageUrl = reader.result;
      };
    },
    async filesChange(fileList) {
      // handle file changes
      const formData = new FormData();

      if (!fileList.length) {
        this.formData = null;
        return;
      }

      // append the files to FormData
      formData.append("file", fileList[0], fileList[0].name);
      if (this.publicFile) {
        formData.append("is_public", true);
      }

      this.uploading = true;

      try {
        const response = await this.$axiosStorageApi.post(
          "/file/upload_auth",
          formData
        );

        this.uploading = false;
        this.$emit("input", response.data.id);
      } catch (e) {
        this.uploading = false;
        // TODO: Display error message
      }
    }
  }
};
</script>
